import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppBar, styled } from '@mui/material';
import { Box } from '@mui/system';
import { NotificationDropdown, ProfileDropdown } from 'app/components/v2';
import { CustomizedToolbar, IconsDiv } from './style';
import { ColorsV2 } from 'app/constants/color';
// import { routes as ROUTES } from 'app/routes';
import OrgSelector from 'app/components/OrgSelector';

const Appbar = () => {
  const navigate = useNavigate();
  // const { pathname } = useLocation();
  // const { t } = useTranslation('translation', { keyPrefix: 'routes' });
  const CustomizedAppbar = styled(AppBar)({
    // width: `calc(100% - ${drawerWidth}px)`,
    width: '100%',
    // ml: `${drawerWidth}px`,
    // background: darkmode ? DarkmodeColors.appBar : 'white',
    background: ColorsV2.primary,
    // borderBottom: darkmode ? `1px solid ${DarkmodeColors.menuIcon}` : '1px solid #E2E3E5',
    height: '64px',
    zIndex: 1200,
    boxShadow: '0px 15px 10px -15px #111',
    marginTop: 'auto',
    marginBottom: 'auto',
    justifyContent: 'center',
  });

  // const returnCurrentPath = () => {
  //   switch (pathname) {
  //     case ROUTES.HOME:
  //       return `  >  ${t('route_1')}`;
  //     case ROUTES.IDENTITY:
  //       return `  >  ${t('route_4')}  >  ${t('route_4_1')}`;
  //     case ROUTES.COMPLIANCE:
  //       return `  >  ${t('route_4')}  >  ${t('route_4_2')}`;
  //     case ROUTES.PRIVACY:
  //       return `  >  ${t('route_12')}`;
  //     case ROUTES.GAP:
  //       return `  >  ${t('route_14')}`;
  //     case ROUTES.MESSAGES:
  //       return `  >  ${t('route_2')}`;
  //     case ROUTES.USERS:
  //       return `  >  ${t('route_3')}  >  ${t('route_3_1')}`;
  //     case ROUTES.SETTINGS:
  //       return `  >  ${t('route_3')}  >  ${t('route_3_2')}`;
  //     default:
  //       return `  >  ${t('route_1')}`;
  //   }
  // };

  return (
    <CustomizedAppbar elevation={0} position='fixed'>
      <CustomizedToolbar>
        <IconsDiv>
          <Box
            display={'flex'}
            alignItems={'center'}
            fontFamily={'Roboto, sans-serif'}
            width={'60%'}
          >
            <img
              onClick={() => navigate('/home')}
              src={'../assets/images/Group-acent.svg'}
              alt='NIC logo'
              style={{ cursor: 'pointer' }}
            />
          </Box>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <OrgSelector></OrgSelector>
            <NotificationDropdown />
            <ProfileDropdown />
          </div>
        </IconsDiv>
      </CustomizedToolbar>
    </CustomizedAppbar>
  );
};

export default Appbar;
